module.exports = __webpack_public_path__ + "static/media/logo-michpal.d3c90b12.png";